import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CertificatesPage } from '@/features/commercial/certificates-page';

const searchSchema = z.object({
  certificate: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/certificates')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <CertificatesPage projectId={projectId} certificate={search.certificate} />;
}
